import { SPAConfig } from "@sphtech/neuron";

// Neuron Configuration
export const NEURON_URL: string = import.meta.env.VITE_NEURON_API_URL;
export const NEURON_TOKEN: string = import.meta.env.VITE_NEURON_API_TOKEN;
export const SEGMENTO_URL: string = import.meta.env.VITE_SEGMENTO_API_URL;

export const neuronConfig: SPAConfig = {
  sessionApiUrl: NEURON_URL,
  sessionApiToken: NEURON_TOKEN,
  segmentsApiUrl: SEGMENTO_URL,
};
